const reasons = [
  {
    icon: 'ri-emotion-unhappy-line',
    title: 'Нет адаптации',
    desc: 'Сотрудника просто «бросают» — сам разбирайся. Без системы онбординга новичок теряется, демотивируется и уходит к конкурентам, где его ждут.',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Нет наставника',
    desc: 'Не к кому обратиться с вопросами. Сотрудник боится выглядеть некомпетентным, копит ошибки и в итоге увольняется, так и не раскрыв потенциал.',
  },
  {
    icon: 'ri-question-mark',
    title: 'Непонятные задачи',
    desc: 'Размытые цели и ожидания. Когда непонятно, что считать хорошим результатом — наступает тревога и выгорание уже на старте.',
  },
  {
    icon: 'ri-feedback-line',
    title: 'Нет обратной связи',
    desc: 'Руководитель молчит неделями. Сотрудник не знает, хорошо ли он работает. Без обратной связи невозможно корректировать действия и развиваться.',
  },
  {
    icon: 'ri-information-line',
    title: 'Перегруз информацией',
    desc: 'В первый день вываливают всё: регламенты, презентации, инструкции. Человек перегружается, ничего не запоминает и чувствует себя некомпетентным.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Слабая корпоративная культура',
    desc: 'Нет ценностей, нет ритуалов, «у нас так принято, но никто не объяснил». Сотрудник не чувствует принадлежности к компании.',
  },
  {
    icon: 'ri-shield-cross-line',
    title: 'Непонятные ожидания',
    desc: 'В описании вакансии одно, в реальности — другое. Несовпадение ожиданий — одна из главных причин увольнений в первые недели работы.',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Ошибки руководителя',
    desc: 'Микроменеджмент или полное игнорирование. Руководитель либо душит контролем, либо забывает о новичке — обе крайности ведут к увольнению.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Нет обучения',
    desc: 'Компания ожидает, что сотрудник уже всё знает. Но в каждой организации свои процессы, продукты и стандарты. Без обучения адаптация невозможна.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Отсутствие поддержки',
    desc: 'Новичок остаётся один на один со стрессом. Без поддержки команды и руководителя даже сильный специалист теряет мотивацию и уходит.',
  },
];

export default function WhyEmployeesLeave() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему сотрудники увольняются в первые месяцы
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          По статистике, <strong>до 40% новых сотрудников увольняются в первые 3-6 месяцев</strong>. Главная причина — не зарплата, а отсутствие системы адаптации персонала. Вот что на самом деле заставляет людей уходить.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-teal-300 transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}